const PROOF = [
  { name: "Trustpilot", score: "4.9", count: "576 reviews" },
  { name: "Google Reviews", score: "4.8", count: "320 reviews" },
  { name: "Checkatrade", score: "9.9", count: "105 reviews" },
  { name: "Which? Trusted", score: "4.8", count: "85 reviews" },
];

export function ProofStrip() {
  const row = (hidden: boolean) => (
    <ul className="flex shrink-0 items-center gap-12 pr-12" aria-hidden={hidden || undefined}>
      <li className="flex items-center gap-2 whitespace-nowrap">
        <span className="text-white/60">Our customers say</span>
        <span className="font-semibold text-white">Excellent</span>
      </li>
      {PROOF.map(p => (
        <li key={p.name} className="flex items-center gap-2.5 whitespace-nowrap">
          <span className="w-1.5 h-1.5 rounded-full bg-[hsl(var(--vx-frost))]" />
          <span className="font-semibold text-white">{p.name}</span>
          <span className="font-display font-bold text-[hsl(var(--vx-frost))]">{p.score}</span>
          <span className="text-white/50">{p.count}</span>
        </li>
      ))}
    </ul>
  );
  return (
    <div className="bg-[hsl(var(--vx-ink-2))] border-y border-white/10 py-4 overflow-hidden text-sm" data-testid="strip-reviews">
      <div className="flex w-max vx-marquee">
        {row(false)}
        {row(true)}
      </div>
    </div>
  );
}
